const info = {
    $schema: '../assetlist.schema.json',
    chain_name: 'unification',
    assets: [{
            description: 'Staking and governance coin for the Unification Blockchain',
            extended_description: 'Fundamentally, the Unification Blockchain Toolkit comprises two core branches: Blockchain Business products, to welcome traditional enterprises into the Web3 economy; and Permissionless Products, an open-access toolkit to power and enrich Dapps on Ethereum/EVM networks',
            denom_units: [{
                    denom: 'nund',
                    exponent: 0
                }, {
                    denom: 'FUND',
                    exponent: 9
                }],
            base: 'nund',
            name: 'Unification Network',
            display: 'FUND',
            symbol: 'FUND',
            images: [{
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg',
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png',
                    theme: {
                        primary_color_hex: '#2279c0'
                    }
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/unification/images/fund.svg'
            },
            socials: {
                website: 'https://unification.com',
                twitter: 'https://twitter.com/UnificationUND'
            },
            coingecko_id: 'unification',
            type_asset: 'sdk.coin'
        }]
};
export default info;
